import type { IUseCase } from 'shared-kernel';
import type { ISecurityRepository } from '../../../domain/ports';
import type { RequestPasswordResetData, PasswordResetResult } from '../../dto/dtos';

export class RequestPasswordResetUseCase implements IUseCase<RequestPasswordResetData, PasswordResetResult> {
  constructor(
    private readonly securityRepository: ISecurityRepository,
  ) {}

  async execute(input: RequestPasswordResetData): Promise<PasswordResetResult> {
    const response = await this.securityRepository.requestPasswordReset(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Echec de la demande de reset');
    }

    return response.data;
  }
}
